import { render, staticRenderFns } from "./Cotizaciones.vue?vue&type=template&id=16e24b19&scoped=true&"
import script from "./Cotizaciones.vue?vue&type=script&lang=js&"
export * from "./Cotizaciones.vue?vue&type=script&lang=js&"
import style0 from "./Cotizaciones.vue?vue&type=style&index=0&id=16e24b19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e24b19",
  null
  
)

export default component.exports